module.exports = __webpack_public_path__ + "img/login-v2-dark.b4bb1ec5.svg";